module.exports = __webpack_public_path__ + "media/images/lp_v6_reserve_txt02-63a21246ccf47f999e3bfd7d1c1d77c1.webp";